import Toastr from '../../../components/Toastr'

const DEFAULT_STATE = {
  inventory_list_items: [],
  meta: {},
  loading: false,
  saving: false,
}

export default function inventoryListItemsReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {
    case 'INVENTORY_LIST_ITEMS_LOAD_PENDING':
      return action.meta?.silent ? state : { ...state, loading: true }

    case 'INVENTORY_LIST_ITEMS_LOAD_REJECTED':
      return { ...state, loading: false, inventory_list_items: [], meta: {} }

    case 'INVENTORY_LIST_ITEMS_LOAD_FULFILLED':
      return {
        ...state,
        loading: false,
        inventory_list_items: response?.inventory_list_items || response?.data?.inventory_list_items || [],
        meta: response?.meta || response?.data?.meta || {},
      }

    case 'INVENTORY_LIST_ITEMS_CREATE_PENDING':
    case 'INVENTORY_LIST_ITEM_UPDATE_PENDING':
    case 'INVENTORY_LIST_ITEM_DELETE_PENDING':
      return { ...state, saving: true }

    case 'INVENTORY_LIST_ITEMS_CREATE_REJECTED':
    case 'INVENTORY_LIST_ITEM_UPDATE_REJECTED':
    case 'INVENTORY_LIST_ITEM_DELETE_REJECTED':
      Toastr.handleShow(false, response?.data?.error || response?.error || 'Request failed', response?.status_code || 422)
      return { ...state, saving: false }

    case 'INVENTORY_LIST_ITEMS_CREATE_FULFILLED':
      Toastr.handleShow(true, response?.meta?.message || 'Inventory list items added successfully', 201)
      return { ...state, saving: false }

    case 'INVENTORY_LIST_ITEM_UPDATE_FULFILLED': {
      const updated = response?.inventory_list_item || response
      return {
        ...state,
        saving: false,
        inventory_list_items: state.inventory_list_items.map((item) => (
          item.id === updated?.id ? updated : item
        )),
      }
    }

    case 'INVENTORY_LIST_ITEM_DELETE_FULFILLED': {
      const deletedId = action.meta?.id || action.payload?.id
      Toastr.handleShow(true, response?.meta?.message || 'Removed from inventory list', 201)
      return {
        ...state,
        saving: false,
        inventory_list_items: state.inventory_list_items.filter((item) => item.id !== deletedId),
      }
    }

    case 'INVENTORY_LIST_ITEM_LOCAL_UPDATE':
      return {
        ...state,
        inventory_list_items: state.inventory_list_items.map((item) => {
          if (item.id !== action.id) return item
          return {
            ...item,
            other_details: {
              ...(item.other_details || {}),
              ...action.changes,
            },
          }
        }),
      }

    default:
      return state
  }
}
